var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',_vm._g(_vm._b({staticClass:"workbench-motion-list",attrs:{"name":"workbench-list","tag":_vm.tag},on:{"before-leave":_vm.disableItem,"before-enter":_vm.restoreItem,"leave-cancelled":_vm.restoreItem}},'transition-group',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }